import script from "./TicketAdvanceFilterDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./TicketAdvanceFilterDialog.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__